import React, { useCallback, useEffect, useState } from 'react';
import { FaCheck, FaPencil, FaXmark } from "react-icons/fa6";
import { useOutsideClick } from "./utils";

interface Props {
    value: string;
    setValue: (value: string) => void;
}

function EditableInput(props: Props) {
    const [edit, setEdit] = useState(false);
    const [value, setValue] = useState(props.value);

    useEffect(() => setValue(props.value), [props.value]);

    const onCancel = useCallback(() => {
        setEdit(false);
        setValue(props.value);
    }, [props.value]);

    const onConfirm = () => {
        setEdit(false);
        props.setValue(value);
    };

    const ref = useOutsideClick(onCancel);

    if (!edit) {
        return (
            <div
                className="editable-field"
                onClick={() => {
                    setEdit(true);
                }}>
               <div>{value}</div>
                <FaPencil />
            </div>
        );
    }

    return (
        <div ref={ref} className="editable-input-field">
            <input
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            <FaCheck className="icon" size="24px" onClick={onConfirm} />
            <FaXmark className="icon" size="24px" onClick={onCancel} />
        </div>
    );
}

export default EditableInput;
